// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fnP13","smallImg":"styles_smallImg__8ayH5","bigImg":"styles_bigImg__EvGYT"};